module.exports = __webpack_public_path__ + "static/duplicate-filters-7130ecc6f2e3decc8d2afbeea6031f41.png";